import { lazy } from 'react';
import {
  ApartmentOutlined,
  BarChartOutlined,
  FileSearchOutlined,
  TableOutlined
} from '@ant-design/icons';
import type { AppRouter } from '@tools/ui/types';

const prefixPath = '/ruby';

const FlowRoutes = lazy(
  () => import(/* webpackChunkName: "RubyRoutes" */ './flow-routes')
);

const FlowExecutionTable = lazy(
  () =>
    import(
      /* webpackChunkName: "RubyRoutes" */ '../pages/flowMonitoring/components/table/flowExecutionTable'
    )
);

const FlowBuilderTab = lazy(
  () =>
    import(/* webpackChunkName: "RubyRoutes" */ '../pages/flow-builder/builder')
);

const AddFlow = lazy(
  () =>
    import(
      /* webpackChunkName: "RubyRoutes" */ '../pages/flow-builder/builder/components/addFlow'
    )
);

const FlowsTable = lazy(
  () => import(/* webpackChunkName: "RubyRoutes" */ '../pages/flows-table')
);

const PaymentLocator = lazy(
  () =>
    import(
      /* webpackChunkName: "RubyRoutes" */ '../pages/paymentLocator/components/paymentLocator'
    )
);

export const rubyRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [prefixPath, `${prefixPath}/*`]
    },
    {
      name: 'Flows Table',
      path: `${prefixPath}/flows-table`,
      component: () => <FlowsTable />,
      pages: [],
      icon: TableOutlined
    },
    {
      name: 'Flow Monitoring',
      path: `${prefixPath}/flow-monitoring`,
      component: () => (
        <FlowRoutes
          component={FlowExecutionTable}
          routeName="Flow Monitoring"
        />
      ),
      pages: [],
      icon: BarChartOutlined
    },
    {
      name: 'Flow Builder',
      path: `${prefixPath}/flow-builder`,
      component: () => (
        <FlowRoutes
          component={FlowBuilderTab}
          routeName="Flow Builder"
          tabBarExtraContent={<AddFlow />}
        />
      ),
      pages: [],
      icon: ApartmentOutlined
    },
    {
      name: 'Payment Locator',
      path: `${prefixPath}/payment-locator`,
      component: PaymentLocator,
      pages: [],
      icon: FileSearchOutlined
    }
  ]
};
